import { useSelector } from 'react-redux';
import betslip from '@gin-betting/betslip';

import { State } from 'types';

const {
    selectors: { selectChosenBetslipBetId },
} = betslip;

interface Output {
    betslipBetId: string | null;
}

const useSelectBetslipBetId = (): Output => {
    const betslipBetId = useSelector((s: State) => selectChosenBetslipBetId(s));

    return { betslipBetId };
};

export default useSelectBetslipBetId;
